import * as THREE from 'three'

class shaderHelper {
    /**
     * @param {string} content
     * @return {?}
     */
    next(content) {
        return content.replace(/#define\sGLSLIFY\s./, "");
    }

    /**
     * @param {!Object} data
     * @return {?}
     */
    normalize(data) {
        return "#include <" + data + ">";
    }
    /**
     * @param {string} chunk
     * @param {string} text
     * @return {undefined}
     */
    addChunk(chunk, text) {
        THREE.ShaderChunk[chunk] = this.next(text);
    };
    /**
     * @param {!Object} o
     * @param {!Object} type
     * @param {string} node
     * @param {?} targetScope
     * @return {?}
     */
    insertBefore(o, type, node, targetScope) {
        if (targetScope) {
            type = this.normalize(type);
        }
        return o.replace(type, this.next(node) + "\n" + type);
    };
    /**
     * @param {string} name
     * @param {string} text
     * @param {string} node
     * @param {?} refNode
     * @return {?}
     */
    insertAfter(name, text, node, refNode) {
        if (refNode) {
            text = this.normalize(text);
        }
        return name.replace(text, text + "\n" + this.next(node) + "\n");
    };
    /**
     * @param {!Object} query
     * @param {string} data
     * @param {string} result
     * @param {?} parentNode
     * @return {?}
     */
    replace(query, data, result, parentNode) {
        if (parentNode) {
            data = this.normalize(data);
        }
        return query.replace(data, "\n" + this.next(result) + "\n");
    };
}

const shaderHelperInstance = new shaderHelper();

export default shaderHelperInstance;
